import { FC, useCallback } from 'react';
import { ORDER_STATUS } from 'src/constants/order';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';

interface IProps {
  orderStatusCode: ORDER_STATUS;
  onClick: (orderStatusCode: ORDER_STATUS) => void;
  loading?: boolean;
}

const statusToTitleMap: { [key: string]: string } = {
  [ORDER_STATUS.ACCEPTED]: 'accept_button',
  [ORDER_STATUS.PROCESSING]: 'process_button',
  [ORDER_STATUS.WAITING_FOR_PICKUP]: 'ready_button',
  [ORDER_STATUS.CANCELED]: 'cancel_order',
  [ORDER_STATUS.COMPLETED]: 'complete_button',
  [ORDER_STATUS.OUT_FOR_DELIVERY]: 'o_status',
  [ORDER_STATUS.PICKEDUP]: ORDER_STATUS.PICKEDUP + '_status',
};

const OrderStatusButton: FC<IProps> = ({ orderStatusCode, onClick, loading }: IProps): JSX.Element => {
  const onButtonClick = useCallback(() => {
    onClick(orderStatusCode);
  }, [orderStatusCode]);

  return (
    <Button
      title={localeStore.t(statusToTitleMap[orderStatusCode])?.toLocaleUpperCase()}
      onClick={onButtonClick}
      loading={loading}
      appearance="primary"
      size="large"
      className="letter-spacing-12"
    />
  );
};

export default OrderStatusButton;
